var _rect, _path, _path2, _path3, _path4, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCrossMark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    rx: 10,
    fill: "url(#paint0_linear_343_2606)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 7L13 12.7001",
    stroke: "url(#paint1_linear_343_2606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.3 7L13 12.7001",
    stroke: "url(#paint2_linear_343_2606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.7L12.7001 7",
    stroke: "url(#paint3_linear_343_2606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7 12.7L12.7001 7",
    stroke: "url(#paint4_linear_343_2606)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_343_2606",
    x1: 20,
    y1: 10.1818,
    x2: 1.61881e-8,
    y2: 10.1818,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.260417,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EDEEEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_343_2606",
    x1: 10.0982,
    y1: 12.7001,
    x2: 10.0982,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F60F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B02A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_343_2606",
    x1: 10.0982,
    y1: 12.7001,
    x2: 10.0982,
    y2: 7,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F60F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B02A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_343_2606",
    x1: 12.7001,
    y1: 9.90182,
    x2: 7,
    y2: 9.90182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F60F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B02A00"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_343_2606",
    x1: 12.7001,
    y1: 9.90182,
    x2: 7,
    y2: 9.90182,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F60F00"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B02A00"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossMark);
export default __webpack_public_path__ + "static/media/cross-mark.9f383747c6e08f285825867dff320fec.svg";
export { ForwardRef as ReactComponent };